<template>
  <Card
    v-bind="$attrs"
    :morph="communication.timeline_morph"
    :pinned="communication.timeline_pinned"
    :simple="simple"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span class="q-pr-xs">
          ({{ $formatSystemDate(communication.timeline_date, fullDate ? luxonFormats.SHORT_WORDED_DATE_TIME : luxonFormats.TIME) }})
        </span>
        <span>
          {{ communication.timeline_morph ? communication.timeline_morph.type : null }} Communication
        </span>
      </div>

      <q-item-label
        v-if="!!communication.complete_msg"
        :class="{'text-red text-bold': communication.failed}"
      >
        {{ communication.complete_msg }}
      </q-item-label>
      <q-item-label caption>
        {{ communication.failed ? 'Failed sending' : 'Sent' }} via {{ via }} to {{ communication.recipient_address }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
    >
      <div class="q-gutter-sm text-h6">
        <q-icon
          v-if="communication.is_read"
          name="mdi-eye-outline"
          :color="color"
        />
        <q-icon
          v-else-if="communication.failed"
          name="mdi-exclamation-thick"
          :color="color"
        />

        <q-icon
          :name="icon"
          :class="{['text-' + color]: true}"
        />
      </div>
    </q-item-section>

    <template #menu>
      <q-item class="q-mb-md">
        <q-item-section>
          <q-item-label>Ref: {{ communication.reference_id }}</q-item-label>
        </q-item-section>
      </q-item>
      <q-item-wrapper
        main-style="max-width: 400px;"
        :icon="icon"
        :label="`Via ${via}`"
        :caption="communication.recipient_address"
      />
      <q-item-wrapper
        v-if="communication.failed"
        color="red-7"
        main-style="max-width: 400px;"
        icon="mdi-exclamation-thick"
        :label="communication.error_msg || 'Failed sending this message'"
      />
      <q-item-wrapper
        v-if="!communication.failed"
        :class="{'text-bold': communication.is_read, 'q-mt-sm': !communication.is_viewable}"
        :color="communication.is_read ? 'green' : 'grey-6'"
        :icon="communication.is_read ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
        :label="`Receiver has ${!communication.is_read ? 'not' : ''} opened the message`"
        :caption="!communication.is_viewable ? 'Message link has expired' : undefined"
        caption-class="text-bold text-red-8"
      />
      <q-item-wrapper
        v-if="!communication.failed && communication.via === 'SMS'"
        caption="SMS communications cannot be tracked easily. If the receiver has clicked a 'More Details' link in the SMS, it will then display as opened"
        caption-class="text-bold text-orange-9"
        main-style="max-width: 400px;"
        class="q-my-sm"
      />
      <q-separator inset class="q-my-sm" />
      <q-item-wrapper
        v-close-popup
        clickable
        icon="mdi-message-text-outline"
        label="View Message..."
        @click="viewingCommunicationID = communication.id"
      />
    </template>
  </Card>

  <ViewMessageDialog
    :id="viewingCommunicationID"
    @close="viewingCommunicationID = null"
  />
</template>

<script>
import Card from 'components/partials/timeline/partials/Card'
import ViewMessageDialog from 'components/partials/communications/ViewMessageDialog'

import communicationMixin from 'components/partials/communications/communicationMixin'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card, ViewMessageDialog
  },
  mixins: [communicationMixin, cardMixin],
  props: {
    communication: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewingCommunicationID: null
    }
  },
  computed: {
    icon () {
      return this.getFieldValue(this.communication.via, 'icon')
    },
    color () {
      return this.communication.failed ? 'red' : this.communication.is_read ? 'green' : 'grey-5'
    },
    via () {
      return this.getFieldValue(this.communication.via, 'label')
    }
  }
}
</script>
